export default {"src":"/_next/static/media/diners-club.e17c3f39.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};